.section {
  display: flex;
  flex-direction: column;
  background: var(--adl-surface-container);
  border: 1px solid var(--adl-border-light);
  border-radius: var(--mantine-radius-sm);
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mantine-spacing-sm);
  width: 100%;
  padding: var(--mantine-spacing-md);
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.title {
  flex: 1;
  font-size: var(--mantine-font-size-md);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.headerRight {
  font-size: var(--mantine-font-size-sm);
  font-weight: 400;
  color: var(--adl-text-secondary);
  white-space: nowrap;
}

.chevron {
  color: var(--adl-text-secondary);
}

.body {
  padding: 0 var(--mantine-spacing-md) var(--mantine-spacing-md);
}
